import { INavService } from '@hubio/hubio-login/lib/models/navigation-service';
import jwt_decode from 'jwt-decode';

export class NavigationService implements INavService {
    constructor() { }
  
    /**
     * Dynamically calculate route to be used as homepage
     * @param token jwt access token
     * @returns relative route in app to be used as homepage
     */
    public calculateHomepageRoute(token: string): string {
      const { 'cognito:groups': groups } = jwt_decode(token) as any;
      const route = (group) => {
        if (groups.includes(group)){
          return groups;
        }
      };

      switch (groups) {
        case route('hubio-c8-download'):
            return '/communic8/';
        default:
            return '/config-manager/';
      }
    }
  }